import { RsValue } from '../../../models/base/BaseModel';
import { IAppointment, AppointmentFormValues } from '../../../models/appointment/AppointmentModel';
import api from '../../axios';

export const appointmentService = {
  listAllAppointments: (
    params?: any
  ): Promise<{ rows: IAppointment[]; lastRow: number; count: number }> =>
    api.get('/odata/Appointment', params),

  getAppointmentById: (id: number): Promise<IAppointment | null> =>
    api.get(`/Appointment/${id}`),

  getAppointmentsByHospitalId: (hospitalId: number): Promise<IAppointment[]> =>
    api.get(`/Appointment/${hospitalId}/appointments`),

  getAppointmentsByPersonId: (personId: number): Promise<IAppointment[]> =>
    api.get(`/Appointment/person/${personId}/appointments`),

  getTodayAppointmentsForUser: (): Promise<IAppointment[]> => {
    const today = new Date();
    const dateStr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
    return api.get('/Appointment/today', { params: { date: dateStr } });
  },

  createAppointment: (data: AppointmentFormValues): Promise<RsValue<IAppointment>> =>
    api.post('/Appointment', {
      hospitalId: data.hospitalId,
      personId: data.personId,
      tagNumberId: data.tagNumberId ?? undefined,
      userId: data.userId || undefined,
      appointmentDate: data.appointmentDate,
      appointmentStartTime: data.appointmentStartTime,
      appointmentEndTime: data.appointmentEndTime,
      deviceList: data.deviceList,
      notes: data.notes || undefined,
      status: data.status || undefined,
      requestNumber: data.requestNumber || undefined,
    }),

  updateAppointment: (id: number, data: AppointmentFormValues): Promise<RsValue<boolean>> =>
    api.put(`/Appointment/${id}`, {
      id: id,
      hospitalId: data.hospitalId,
      personId: data.personId,
      tagNumberId: data.tagNumberId ?? undefined,
      userId: data.userId || undefined,
      appointmentDate: data.appointmentDate,
      appointmentStartTime: data.appointmentStartTime,
      appointmentEndTime: data.appointmentEndTime,
      deviceList: data.deviceList,
      notes: data.notes || undefined,
      status: data.status || undefined,
      requestNumber: data.requestNumber || undefined,
    }),

  deleteAppointment: (id: number): Promise<RsValue<boolean>> => api.delete(`/Appointment/${id}`),
};
